import { Component, OnInit } from '@angular/core';
import anime from 'animejs';

@Component({
    selector: 'pz-login-bg',
    templateUrl: './login-bg.component.html',
    styleUrls: ['./login-bg.component.scss']
})
export class LoginBgComponent implements OnInit {
    public paths: any[];
    public constructor() {
        //
    }
    public ngOnInit() {
        this.paths = Array.from(document.querySelector('svg.scene')
            .querySelectorAll('path'));
        this.paths.forEach((path) => {
            setTimeout(() => {
                anime({
                    targets: path,
                    duration: anime.random(3000, 5000),
                    easing: 'cubicBezier(.5, .05, .1, .3)',
                    d: path.getAttribute('pathdata:id'),
                    loop: true,
                    direction: 'alternate'
                });
            }, anime.random(0, 1000));
        });
    }
}
